(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat('fr-FR', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(cents / 100);
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const cartDialog = document.getElementById('bibi-cart-dialog');
  const searchDialog = document.getElementById('bibi-search-dialog');
  const cartAnnouncement = document.createElement('p');
  cartAnnouncement.className = 'bibi-cart-announcement';
  cartAnnouncement.setAttribute('role', 'status');
  cartAnnouncement.setAttribute('aria-live', 'polite');
  cartAnnouncement.setAttribute('aria-atomic', 'true');
  cartDialog?.append(cartAnnouncement);
  function restoreCartFocus(key) {
    if (!cartDialog?.open) return;
    if (document.activeElement !== document.body && document.activeElement !== cartDialog) return;
    const fields = [...cartDialog.querySelectorAll('[data-cart-quantity]')];
    const next = fields.find(field => field.dataset.cartQuantity === key) || fields[0] || cartDialog.querySelector('[data-close-dialog]');
    next?.focus({ preventScroll: true });
  }
  const setCartCount = count => document.querySelectorAll('[data-cart-count]').forEach(element => {
    element.textContent = count;
    element.closest('button')?.setAttribute('aria-label', `Panier, ${count} articles`);
  });
  let cartRequests = 0;
  let cartPageDirty = false;
  cartDialog?.addEventListener('close',() => {
    if (cartPageDirty && document.getElementById('BibiCartForm')) location.reload();
  });
  function setCartBusy(busy) {
    cartRequests = Math.max(0,cartRequests + (busy ? 1 : -1));
    const pending = cartRequests > 0;
    cartDialog?.querySelector('[data-cart-content]')?.setAttribute('aria-busy',String(pending));
    cartDialog?.querySelectorAll('[data-cart-quantity],[data-cart-remove],[data-bibi-offer-add] button,[data-bibi-trio-add] button,[data-cart-checkout] button').forEach(control => { control.disabled = pending; });
  }
  async function cartRequest(path, body) {
    setCartBusy(true);
    try {
      const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{'Accept':'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Une erreur est survenue. Réessayez.');
      if (body && document.getElementById('BibiCartForm')) cartPageDirty = true;
      return result;
    } finally { setCartBusy(false); }
  }
  const offerCatalog = (() => {
    try { return JSON.parse(document.querySelector('[data-bibi-offer-catalog]')?.textContent || '[]'); }
    catch { return []; }
  })();
  const bundleContents = (() => {
    try { return JSON.parse(document.querySelector('[data-bibi-bundle-contents]')?.textContent || '{}'); }
    catch { return {}; }
  })();
  const lineContainsProduct = (item, productId) => {
    const target = String(productId);
    if (String(item.product_id) === target) return true;
    if ((bundleContents[String(item.product_id)] || []).some(id => String(id) === target)) return true;
    return Array.isArray(item.item_components) && item.item_components.some(component => lineContainsProduct(component, target));
  };
  const cartContains = (cart, productId) => cart.items.some(item => lineContainsProduct(item, productId));
  const cartCopy = (() => {
    try { return JSON.parse(document.querySelector('[data-bibi-cart-copy]')?.textContent || '{}'); }
    catch { return {}; }
  })();
  let lastShippingTotal = Number(cartCopy.initialTotal) || 0;
  function shippingProgress(cart) {
    if (cart.currency !== 'EUR') return '';
    const total = Math.max(0, Number(cart.total_price) || 0);
    const remaining = Math.max(0, 5000 - total);
    const unlocked = remaining === 0;
    const celebrate = unlocked && lastShippingTotal < 5000;
    const previous = Math.min(1, Math.max(0, lastShippingTotal / 5000));
    const next = Math.min(1, total / 5000);
    const message = unlocked ? cartCopy.unlocked : String(cartCopy.remaining || '').replace('__amount__', money(remaining));
    return `<div class="bibi-cart-shipping${unlocked ? ' is-unlocked' : ''}${celebrate ? ' is-celebrating' : ''}"><p><span class="bibi-cart-shipping__icon" aria-hidden="true">${unlocked ? '🎉' : '🎁'}</span> ${escapeHTML(message)}</p><div class="bibi-cart-shipping__track" role="progressbar" aria-label="${escapeHTML(cartCopy.progressLabel)}" aria-valuemin="0" aria-valuemax="5000" aria-valuenow="${Math.min(5000,total)}" aria-valuetext="${escapeHTML(message)}"><span data-shipping-fill data-fill="${next}" style="transform:scaleX(${previous})"></span></div><small>${escapeHTML(cartCopy.country)}</small></div>`;
  }
  const trioKinds = ['biberon-pp-anti-colique-poignees-240ml','set-brosses-biberon-silicone','egouttoir-biberons-vertical'];
  const trioCatalog = trioKinds.map(kind => offerCatalog.find(item => item.kind === kind)).filter(Boolean);
  const offerFitsCart = (item, cart) => !(item.excludedFor || []).some(id => cartContains(cart,id));
  const missingTrio = cart => trioCatalog.filter(item => !cartContains(cart,item.productId) && offerFitsCart(item,cart));
  function renderTrio(cart) {
    const items = missingTrio(cart), copy = cartCopy.trio || {};
    if (!items.length || !cart.item_count) return '';
    const title = item => copy[item.kind === trioKinds[0] ? 'bottle' : item.kind === trioKinds[1] ? 'brush' : 'rack'] || item.title;
    const total = items.reduce((sum,item) => sum + Number(item.price),0);
    const mealBottleIncluded = items.some(item => (item.mealBottleFor || []).some(id => cartContains(cart,id)));
    const kitMealNote = mealBottleIncluded && copy.kit_meal_note ? `<p class="bibi-trio__note">${escapeHTML(copy.kit_meal_note)}</p>` : '';
    const label = items.length === 1 ? copy.add_one : String(copy.add_many || '').replace('__count__',items.length);
    const rows = items.map(item => `<div class="bibi-trio__item"><a href="${escapeHTML(item.url)}"><img src="${escapeHTML(item.image)}" width="42" height="42" loading="lazy" alt="${escapeHTML(title(item))}"></a><a href="${escapeHTML(item.url)}"><strong>${escapeHTML(title(item))}</strong></a><span>${money(item.price)}</span></div>`).join('');
    const inputs = items.map((item,index) => `<input type="hidden" name="items[${index}][id]" value="${item.variantId}"><input type="hidden" name="items[${index}][quantity]" value="1">`).join('');
    return `<section class="bibi-cart-trio" aria-label="${escapeHTML(copy.heading)}"><h2>${escapeHTML(copy.heading)}</h2><p class="bibi-trio__note">${escapeHTML(copy.note)}</p>${kitMealNote}${rows}<form action="${root}cart/add" method="post" data-bibi-trio-add>${inputs}<div class="bibi-trio__footer"><div><small>${escapeHTML(copy.added_total)}</small><strong>${money(total)}</strong></div><button type="submit" class="bibi-button">${escapeHTML(label)}</button></div><p role="status" data-offer-status></p></form></section>`;
  }
  function cartOffer(cart) {
    if (trioCatalog.length === 3) return renderTrio(cart);
    const availableOffers = offerCatalog.filter(item => !cartContains(cart,item.productId) && offerFitsCart(item,cart));
    const offer = availableOffers.find(item => item.preferredFor?.some(id => cartContains(cart,id))) || availableOffers[0];
    if (!offer || !cart.item_count) return '';
    const title = offer.kind === 'set-brosses-biberon-silicone' ? cartCopy.brushTitle : offer.kind === 'biberon-pp-anti-colique-poignees-240ml' ? cartCopy.bottleTitle : offer.title;
    return `<section class="bibi-cart-offer bibi-cart-offer--compact" aria-label="${escapeHTML(cartCopy.offerLabel)}"><a href="${escapeHTML(offer.url)}"><img src="${escapeHTML(offer.image)}" width="52" height="52" loading="lazy" alt="${escapeHTML(title)}"></a><div class="bibi-cart-offer__info"><a href="${escapeHTML(offer.url)}"><strong>${escapeHTML(title)}</strong></a><span>${money(offer.price)}</span></div><form action="${root}cart/add" method="post" data-bibi-offer-add><input type="hidden" name="id" value="${offer.variantId}"><input type="hidden" name="quantity" value="1"><button class="bibi-button" type="submit" aria-label="${escapeHTML(cartCopy.add + ' ' + title)}">${escapeHTML(cartCopy.add)}</button><p role="status" data-offer-status></p></form></section>`;
  }
  function updateBundles(variant) {
    for (const bundle of document.querySelectorAll('[data-bibi-bundle]')) {
      bundle.querySelector('[data-bundle-main]').value=variant.id;
      bundle.querySelector('button[type="submit"]').disabled=!variant.available;
      const total = Number(variant.priceCents)+Number(bundle.dataset.companionPrice);
      const price = bundle.querySelector('[data-bundle-total]');
      if (Number.isFinite(total) && price) price.textContent=money(total);
    }
  }

  function renderCart(cart) {
    setCartCount(cart.item_count);
    const cartMessage = String(cartCopy.updated || 'Panier mis à jour. Sous-total : __total__.').replace('__total__', money(cart.total_price));
    if (cartAnnouncement.textContent !== cartMessage) cartAnnouncement.textContent = cartMessage;
    document.querySelectorAll('[data-companion-product]').forEach(card => { card.hidden = cartContains(cart,card.dataset.companionProduct); });
    const target = cartDialog?.querySelector('[data-cart-content]');
    if (!target) return;
    const checkout = cartDialog.querySelector('[data-cart-checkout]');
    if (checkout) { checkout.hidden = true; checkout.innerHTML = ''; }
    if (!cart.item_count) {
      lastShippingTotal = 0;
      target.innerHTML = `<p>Votre panier est vide.</p><a class="bibi-button" href="${root}collections/tous-les-produits">Découvrir les produits</a>`;
      return;
    }
    const lines = cart.items.map(item => `<div class="bibi-cart-line"><a href="${escapeHTML(item.url)}">${item.image ? `<img src="${escapeHTML(item.image)}" width="100" height="100" alt="${escapeHTML(item.product_title)}">` : ''}</a><div><a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.product_title)}</strong></a><p>${escapeHTML(item.variant_title === 'Default Title' ? '' : item.variant_title)}</p>${item.quantity > 1 ? `<small class="bibi-cart-unit-price">${item.quantity} × ${money(item.final_price)}</small>` : ''}<label>Quantité <input type="number" min="0" max="99" value="${item.quantity}" aria-label="${escapeHTML((cartCopy.quantityLabel || 'Quantité pour') + ' ' + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : ''))}" data-cart-quantity="${escapeHTML(item.key)}"></label><button type="button" aria-label="${escapeHTML((cartCopy.removeLabel || 'Retirer') + ' ' + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : ''))}" data-cart-remove="${escapeHTML(item.key)}">Retirer</button></div><strong>${money(item.final_line_price)}</strong></div>`).join('');
    const summary = `<div class="bibi-cart-summary bibi-cart-summary--drawer"><p>${escapeHTML(cartCopy.subtotal)} <strong>${money(cart.total_price)}</strong></p><form action="${root}cart" method="post"><button type="submit" name="checkout" class="bibi-button">${escapeHTML(cartCopy.checkout)}</button></form></div>`;
    target.innerHTML = `${lines}${shippingProgress(cart)}${cartOffer(cart)}`;
    lastShippingTotal = Math.max(0, Number(cart.total_price) || 0);
    const fill = target.querySelector('[data-shipping-fill]');
    if (fill) requestAnimationFrame(() => { if (fill.isConnected) fill.style.transform = 'scaleX(' + fill.dataset.fill + ')'; });
    if (checkout) { checkout.innerHTML = summary; checkout.hidden = false; }
    else { target.insertAdjacentHTML('beforeend',summary); }

  }
  async function openCart() {
    if (!cartDialog) { location.href = root + 'cart'; return; }
    cartDialog.showModal();
    const content = cartDialog.querySelector('[data-cart-content]');
    const checkout = cartDialog.querySelector('[data-cart-checkout]');
    if (checkout) checkout.hidden = true;
    content.textContent = 'Chargement du panier…';
    try { renderCart(await cartRequest('cart.js')); }
    catch (error) { content.textContent = error.message; }
  }
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); await openCart(); }
    if (event.target.closest('[data-search-open]')) { searchDialog?.showModal(); searchDialog?.querySelector('input')?.focus(); }
    const closer = event.target.closest('[data-close-dialog]');
    if (closer) closer.closest('dialog')?.close();
    const menuButton = event.target.closest('[data-menu-toggle]');
    if (menuButton) {
      const header = menuButton.closest('.bibi-header');
      const open = header.classList.toggle('menu-open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      if (!open) header.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
    }
    if (!event.target.closest('.bibi-nav')) document.querySelectorAll('.bibi-nav details[open]').forEach(detail => { detail.open = false; });
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      remove.disabled = true;
      try {
        const key = remove.dataset.cartRemove;
        const cart = await cartRequest('cart/change.js', {id:key,quantity:0});
        renderCart(cart);
        restoreCartFocus(key);
        cartAnnouncement.textContent = String(cartCopy.removed || 'Article retiré. Sous-total : __total__.').replace('__total__', money(cart.total_price));
      }
      catch (error) { remove.disabled = false; alert(error.message); }
    }
    if (event.target.closest('[data-mobile-add]')) document.querySelector('.bibi-product-form')?.requestSubmit(document.querySelector('.bibi-add-button'));
  });
  document.addEventListener('change', async event => {
    if (event.target.matches('[data-sort-select]')) event.target.form.submit();
    if (event.target.matches('[data-cart-quantity]')) {
      const input = event.target;
      input.disabled = true;
      try {
        const key = input.dataset.cartQuantity;
        const cart = await cartRequest('cart/change.js',{id:key,quantity:Math.max(0,Number(input.value)||0)});
        renderCart(cart);
        restoreCartFocus(key);
      }
      catch (error) { input.disabled = false; alert(error.message); }
    }
  });
  function gallerySrcset(image) {
    const maximum = Math.min(1400, Number(image.width) || 1400);
    const widths = [360, 540, 750, 1000, 1400].filter(width => width < maximum);
    widths.push(maximum);
    return widths.map(width => {
      const source = new URL(image.src, location.href);
      source.searchParams.set('width', String(width));
      return source.href + ' ' + width + 'w';
    }).join(', ');
  }
  for (const container of document.querySelectorAll('[data-bibi-product]')) {
    const data = JSON.parse(container.querySelector('[data-product-data]').textContent);
    const form = container.querySelector('.bibi-product-form');
    const stage = container.querySelector('.bibi-gallery-stage');
    const dots = container.querySelector('.bibi-gallery-dots');
    const thumbs = container.querySelector('.bibi-gallery-thumbs');
    const prev = container.querySelector('.bibi-gallery-prev');
    const next = container.querySelector('.bibi-gallery-next');
    let images = data.images;
    let index = 0;
    let selected = data.variants.find(variant => String(variant.id) === form.elements.id.value) || data.variants[0];
    function showImage(newIndex) {
      index = Math.max(0,Math.min(newIndex,images.length-1));
      const image = images[index];
      if (!image) return;
      const element = stage.querySelector('img') || document.createElement('img');
      element.sizes = '(min-width: 1600px) 850px, (min-width: 750px) 54vw, calc(100vw - 24px)';
      element.srcset = gallerySrcset(image);
      element.src = image.src;
      element.alt = image.alt;
      element.width = Number(image.width) || 1400;
      element.height = Number(image.height) || 1400;
      element.loading = 'eager';
      element.decoding = 'async';
      element.fetchPriority = index === 0 ? 'high' : 'auto';
      if (stage.firstElementChild !== element) stage.replaceChildren(element);
      stage.setAttribute('aria-label', `Photo ${index+1} sur ${images.length}`);
      dots.querySelectorAll('button').forEach((button,position) => button.setAttribute('aria-selected',String(position===index)));
      thumbs.querySelectorAll('button').forEach((button,position) => button.setAttribute('aria-current',String(position===index)));
      prev.disabled = index===0;
      next.disabled = index===images.length-1;
    }
    function updateGallery() {
      images = data.handle==='chauffe-biberon-nomade-numerique' ? data.images.filter(image => image.rose === selected.options.includes('Rose clair')) : data.images;
      dots.replaceChildren(); thumbs.replaceChildren();
      images.forEach((image,position) => {
        const dot = document.createElement('button');
        dot.type='button';dot.setAttribute('role','tab');dot.setAttribute('aria-label',`Afficher la photo ${position+1}`);
        dot.addEventListener('click',()=>showImage(position));dots.append(dot);
        const thumb = document.createElement('button');thumb.type='button';thumb.setAttribute('aria-label',`Afficher la photo ${position+1}`);
        const picture = document.createElement('img');picture.src=image.thumb;picture.alt=image.alt;picture.width=180;picture.height=180;picture.loading='lazy';
        thumb.append(picture);thumb.addEventListener('click',()=>showImage(position));thumbs.append(thumb);
      });
      showImage(0);
    }
    prev.addEventListener('click',()=>showImage(index-1));next.addEventListener('click',()=>showImage(index+1));
    let touchStart=0;
    stage.addEventListener('touchstart',event=>{touchStart=event.changedTouches[0].clientX;},{passive:true});
    stage.addEventListener('touchend',event=>{const distance=event.changedTouches[0].clientX-touchStart;if(Math.abs(distance)>45)showImage(index+(distance<0?1:-1));},{passive:true});
    form.addEventListener('change',event=>{
      if (!event.target.matches('input[type="radio"]')) return;
      const values=[...form.querySelectorAll('fieldset')].map(field=>field.querySelector('input:checked')?.value);
      const variant=data.variants.find(item=>item.options.every((option,position)=>option===values[position]));
      if (!variant) return;
      selected=variant;form.elements.id.value=variant.id;
      updateBundles(variant);
      container.querySelector('[data-product-price]').innerHTML=variant.price;
      form.querySelectorAll('fieldset').forEach((field,position)=>{field.querySelector('[data-option-label]').textContent=values[position];});
      const button=form.querySelector('.bibi-add-button');button.disabled=!variant.available;button.textContent=variant.available?'Ajouter au panier':'Indisponible';
      document.querySelectorAll('[data-mobile-add]').forEach(button => { button.disabled=!variant.available;button.textContent=variant.available?'Ajouter au panier':'Indisponible'; });
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      updateGallery();
    });
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      const button=form.querySelector('.bibi-add-button'),error=form.querySelector('[data-product-error]');
      error.textContent='';button.disabled=true;button.textContent='Ajout en cours…';
      try { await cartRequest('cart/add.js',{items:[{id:Number(form.elements.id.value),quantity:1}]});await openCart(); }
      catch (failure) { error.textContent=failure.message; }
      finally { button.disabled=!selected.available;button.textContent=selected.available?'Ajouter au panier':'Indisponible'; }
    });
    updateGallery();
    updateBundles(selected);
    document.querySelectorAll('[data-mobile-add]').forEach(button => { button.disabled=!selected.available;button.textContent=selected.available?'Ajouter au panier':'Indisponible'; });
  }
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-bibi-offer-add],[data-bibi-bundle],[data-bibi-trio-add]')) return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]'),status=form.querySelector('[data-offer-status]');
    if (button.disabled) return;
    const label=button.textContent;
    button.disabled=true;button.textContent=cartCopy.trio?.adding || 'Ajout en cours…';status.textContent='';
    const isBundle=form.matches('[data-bibi-bundle]');
    const isTrio=form.matches('[data-bibi-trio-add]');
    let items=isTrio ? [] : isBundle ? [
      {id:Number(form.querySelector('[data-bundle-main]').value),quantity:1},
      {id:Number(form.querySelector('[data-bundle-companion]').value),quantity:1}
    ] : [{id:Number(form.elements.id.value),quantity:1}];
    try {
      if (isTrio) {
        const freshCart = await cartRequest('cart.js');
        const selectedIds = new Set([...form.querySelectorAll('input[name$="[id]"]')].map(input => String(input.value)));
        items = missingTrio(freshCart).filter(item => selectedIds.has(String(item.variantId))).map(item => ({id:Number(item.variantId),quantity:1}));
        if (!items.length) { renderCart(freshCart); if (form.closest('[data-bibi-cart-offer-page]')) location.reload(); return; }
      }
      await cartRequest('cart/add.js',{items});
      if (form.closest('[data-bibi-cart-offer-page]')) { location.href=root+'cart'; return; }
      await openCart();
      cartDialog?.querySelector('button[name="checkout"]')?.focus();
    } catch(failure) { status.textContent=failure.message; }
    finally { if (button.isConnected) {button.disabled=false;button.textContent=label;} }
  });

  const mobileCheckout = document.querySelector('[data-cart-mobile-checkout]');
  const pageCheckout = document.getElementById('BibiCartCheckout');
  if (mobileCheckout && pageCheckout && 'IntersectionObserver' in window) {
    const checkoutObserver = new IntersectionObserver(entries => { mobileCheckout.hidden = entries[0].isIntersecting; },{threshold:0});
    checkoutObserver.observe(pageCheckout);
  }

  document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.bibi-nav details[open]').forEach(detail=>{detail.open=false;});const button=document.querySelector('.bibi-header.menu-open [data-menu-toggle]');if(button)button.click();}});
  for (const dialog of document.querySelectorAll('dialog')) dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
})();




